const createFormData = (input: Record<string, any>): FormData => {
  return Object.keys(input || {}).reduce((formData, key) => {
    const property = input[key];
    formData.append(
      key,
      property instanceof Blob
        ? property
        : typeof property === 'object' && property !== null
          ? JSON.stringify(property)
          : `${property}`
    );
    return formData;
  }, new FormData());
};

export { createFormData };
